/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FileTypes {
  ApplicationPdf = 'application/pdf',
  ImageHeic = 'image/heic',
  ImageHeif = 'image/heif',
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png'
}
